import React from 'react';
import { STAFF_PATHS } from '../../../../_configuration';
import { generatePath, useHistory } from 'react-router';

// Material UI
import Typography from '@material-ui/core/Typography';
import { Bold } from '../../_core/_ui/typography.component';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';

// Components
import { PrimaryButton } from '../../_core/_ui/buttons.component';
import ApproveRoutesGraphQL from '../ApproveRoutes/approve-routes.graphql';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { pluralTerm } from '../../../lib/helpers/term.helper';
import { SportTerminology } from '../../../lib/types';

interface IRouteStageHandler {
  stage: IAssessmentStage;
  ageGroup: IAgeGroup;
  isNext?: boolean;
  isSummary?: boolean;
}

export const RouteStageHandler: React.FC<IRouteStageHandler> = ({
  ageGroup,
  stage,
  isNext,
  isSummary
}) => {
  const termLookup = useCompanySportTerminology();
  const athletesTerm = pluralTerm(termLookup[SportTerminology.ATHLETE]);

  const history = useHistory();
  const content = [];

  if (!isNext) {
    content.push(
      <Typography key="title" variant="subtitle1"><Bold>Current Stage:</Bold> Route {athletesTerm}</Typography>,
    );
    content.push(<Box my={1} key="divider"><Divider/></Box>);

    if (isSummary) {
      content.push(
        <PrimaryButton fullWidth onClick={() => history.push(generatePath(STAFF_PATHS.AGE_GROUP, { ageGroupId: ageGroup._id }))} key="review">Review & Approve
          Routes</PrimaryButton>
      );
    } else {
      content.push(<ApproveRoutesGraphQL ageGroupId={ageGroup._id} stage={stage} />);
    }
  } else {
    content.push(<Box mt={2}><Typography key="first" variant="subtitle1"><Bold>Next Stage:</Bold> Route {athletesTerm}</Typography></Box>);
  }

  return <>{content}</>;
};
